import {
  Component,
  AfterViewInit,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { ScriptLoaderService } from './script-loader.service';
import { LoaderService } from './shared/network/services/loader.service';
import { Subject, BehaviorSubject } from 'rxjs';
declare var $;
declare var jQuery;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class AppComponent implements OnInit, AfterViewInit {
  stateChange = new BehaviorSubject<boolean>(false);

  title = 'HiLocals-AdminTheme';
  constructor(
    private loaderSerivce: ScriptLoaderService,
    private loaderService: LoaderService
  ) {
    this.loaderService.loader.subscribe(value => {
      this.stateChange.next(value);
    });
  }
  ngOnInit() {}
  ngAfterViewInit() {
    this.loaderSerivce.loadScripts('body', [
      'assets/libs/jquery/dist/jquery.min.js',
      'assets/libs/select2/dist/js/select2.full.min.js',
      'assets/libs/select2/dist/js/select2.min.js',
      'assets/libs/jquery-steps/build/jquery.steps.min.js',
      'assets/libs/jquery-validation/dist/jquery.validate.min.js',
      'assets/libs/flot/jquery.flot.js',
      'assets/libs/flot/jquery.flot.pie.js',
      'assets/libs/flot/jquery.flot.time.js',
      'assets/libs/flot/jquery.flot.stack.js',
      'assets/libs/flot/jquery.flot.crosshair.js',
      'assets/js/jquery.ui.touch-punch-improved.js',
      'assets/js/jquery-ui.min.js',
      'assets/libs/inputmask/dist/min/jquery.inputmask.bundle.min.js',
      'assets/js/pages/mask/mask.init.js',
      'assets/libs/popper.js/dist/umd/popper.min.js',
      'assets/libs/bootstrap/dist/js/bootstrap.min.js',
      'assets/extra-libs/sparkline/sparkline.js',
      'assets/js/waves.js',
      'assets/libs/toastr/build/toastr.min.js',
      'assets/libs/flot/excanvas.js',
      'assets/libs/flot.tooltip/js/jquery.flot.tooltip.min.js',
      'assets/js/pages/calendar/cal-init.js',
      'assets/libs/moment/min/moment.min.js',
      'assets/libs/fullcalendar/dist/fullcalendar.min.js',
      'assets/libs/inputmask/dist/min/jquery.inputmask.bundle.min.js',
      'assets/js/pages/mask/mask.init.js',
      'assets/libs/jquery-asColor/dist/jquery-asColor.min.js',
      'assets/libs/jquery-asGradient/dist/jquery-asGradient.js',
      'assets/libs/jquery-asColorPicker/dist/jquery-asColorPicker.min.js',
      'assets/libs/jquery-minicolors/jquery.minicolors.min.js',
      'assets/libs/bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js',
      'assets/libs/quill/dist/quill.min.js'
    ]);
  }
}
